import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import CreaterForApp from "../CreaterForApp";
import CreaterForWidget from "../CreaterForWidget";
import CreaterPubWidget from "../CreaterPubWidget";
import { useOprArea } from "../hooks";
import { PUB_WIDGET_APPCODES, getScale, checkApp, getSpecialColor } from "../utilService";
import { getCurrentLangText } from "Pub/js/getMulti";
import NoAuthority from "Components/NoAuthority";
import platform from "Pub/js/platform";
import { getCurrentBgImg, getCurrentAppBg } from "Pub/js/backgroundImg";
const { PubSub } = platform;
import { connect } from "react-redux";
import { langCheck } from "Pub/js/utils";

function GridItem(props) {
    const [renderable, setRenderable] = useState(false);
    const gridItemRef = useRef();
    const { item, renderLinkageIcons } = props;
    let io; // IntersectionObserver监听器
    useEffect(() => {
        // console.log('GridItem: ', props.item.name);
        io = new IntersectionObserver(handleRender, { root: null, rootMargin: '0px 0px', threshold: 0 });
        let linkWidgetMountedCount = 0;
        const { linkRelation } = props;
        let linkageWidgetMountedPub;
        if (linkRelation[item.cardid] && !interdependence(item.cardid)) { // 需要等被依赖的都挂载了，自己才可以渲染，互相依赖的不处理
            linkageWidgetMountedPub = PubSub.subscribe('linkageWidgetMounted', (action, key) => {
                if (linkRelation[item.cardid].includes(key)) {
                    linkWidgetMountedCount++;
                    // console.log('linkageWidgetMounted', item.name, linkWidgetMountedCount, linkRelation[item.cardid].length);
                    if (linkWidgetMountedCount === linkRelation[item.cardid].length) { // 说明被依赖的已经全部挂载完了
                        startRender();
                    }
                }
            })
        } else {
            startRender();
        }

        return () => {
            // console.log('卸载');
            io.disconnect();
            linkageWidgetMountedPub && PubSub.unsubscribe(linkageWidgetMountedPub);
        };
    }, []);

    const startRender = () => {
        io.observe(gridItemRef.current);
    }

    // 互相依赖
    const interdependence = (cardid) => {
        const { linkRelation } = props;
        for (let val of linkRelation[cardid]) {
            if (linkRelation[val] && linkRelation[val].includes(cardid)) {
                return true;
            }
        }
    }

    // 不需要懒加载
    const needNotLazy = () => {
        // 常用链接和快速发起是有单独的保存接口的，如果不在屏幕范围内卸载了的话，将无法保存
        return getLinkRelationFlag() || checkApp(item).isExternalLink || checkApp(item).isQuickLaunch;
    };

    // 渲染处理
    const handleRender = (entries) => {
        const { editable } = props;
        const noLazy = needNotLazy();
        const { isIntersecting } = entries.pop();
        // console.log(props.item.name, isLinkRelation);
        if (isIntersecting || noLazy) { // 在屏幕范围内或者不需要懒加载的
            setRenderable(true);
            (!editable || noLazy) && io.unobserve(gridItemRef.current); // 浏览态或者有联动关系的渲染完毕清除滚动监听
        } else { // 屏幕范围之外
            setRenderable(false);
        }
    }

    const getLinkRelationFlag = () => {
        // 有关联关系的
        const { linkRelation } = props;
        for (let k in linkRelation) {
            if (k === item.cardid || linkRelation[k].includes(item.cardid)) {
                return true;
            }
        }
        return false;
    }

    // 渲染头部自定义区域
    const renderHeaderCustomArea = (dom, areaClass = '') => {
        const cusDom = gridItemRef.current.querySelector('.header-custom');
        if (cusDom) {
            ReactDOM.render(
                dom,
                cusDom
            );
            if (![...cusDom.classList].includes('rendered')) {
                cusDom.classList.add('rendered');
                areaClass && cusDom.classList.add(areaClass);
            }
        }
    }

    const getBgStyle = () => {
        const checkItem = checkApp(item);
        const { sideData = {} } = item;
        let bgStyle = {};
        const commonBgStyle = {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        };
        if (checkItem.isApp) { // 应用
            const { background = {} } = sideData;
            const { show } = background;
            if (show) {
                bgStyle = { ...commonBgStyle, backgroundImage: `url(${getCurrentAppBg(background.pictureKey, props.themeColor)})` };
            }
        } else { // 部件
            const { publicData = {} } = sideData;
            const { background = {} } = publicData;
            if (background.type === 'color' && background.color) {
                bgStyle.backgroundColor = getSpecialColor(background.color, props.themeColor);
            } else if (background.type === 'picture' && background.picture) {
                bgStyle = { ...commonBgStyle, backgroundImage: `url(${getCurrentBgImg(background.pictureKey, props.themeColor) || background.picture})` };
            }
        }
        return bgStyle;
    }

    const renderItem = () => {
        const { zoom, narrow } = getScale();
        const scaleStyle = (props.isScale) ? {
            width: `${zoom * 100}%`,
            height: `${zoom * 100}%`,
            transform: `scale(${narrow})`
        } : {}
        const style = {
            // opacity: item.haspower === false ? 0.6 : 1,
            ...scaleStyle
        }
        const { haspower = true } = item;
        const bgStyle = getBgStyle();
        //判断应用和部件
        switch (Number(item.apptype)) {
            case 1:
                return <CreaterForApp key={item.cardid} appData={item} style={{ ...style, ...bgStyle }} {...props} displayMode={Object.keys(bgStyle).length ? 'center' : 'default'}>
                    {!haspower && <NoAuthority />}
                </CreaterForApp>;
            case 2:
                const checkItem = checkApp(item);
                const newProps = { ...props, renderHeaderCustomArea, isPublished: checkItem.isPublished };
                const { sideData = {} } = item;
                const { publicData = {} } = sideData;
                const publicName = getCurrentLangText('name', publicData);
                const needHeader = item.iscommon_configuration && !checkItem.isCommonUsedApp;
                const linkageIcons = needHeader ? renderLinkageIcons() : null;
                // grid-${item.appcode} 这个类是给领域用的，用于重写指定小部件的样式
                return <div className={classNames("grid-item flex-col", `grid-${item.appcode}`, { scale: props.isScale })} style={{ ...style, ...bgStyle }}>
                    {
                        needHeader && <div className="grid-item-header">
                            {
                                publicData.nameShow && <div className={`header-name ${publicName && !linkageIcons ? 'right-margin' : ''}`}>{publicName}</div>
                            }
                            {
                                linkageIcons && <div className="linkage-icons-container">{linkageIcons}</div>
                            }
                            <div className="header-custom"></div>
                        </div>
                    }
                    <div className="grid-item-main">
                        {
                            Object.values(PUB_WIDGET_APPCODES).includes(item.source_app_code || item.appcode) //公共类部件
                                ?
                                <CreaterPubWidget key={item.cardid} appOption={item} {...newProps} />
                                :
                                <CreaterForWidget key={item.cardid} appOption={item} style={style} {...newProps} needRecordMounted={true} />
                        }
                    </div>
                    {!haspower && <NoAuthority text={langCheck('0000PUB-000634', false, null, [item.name])} />}
                </div>
            default:
                break;
        }
    };

    let passiveLinkElements = [];
    let activeLinkElement = null;
    const handleMouseEnter = () => {
        const { linkRelation, editable } = props;
        const { cardid } = item;
        if (!editable && linkRelation[cardid]) {
            activeLinkElement = document.getElementById(cardid);
            passiveLinkElements = [...document.querySelectorAll('.gird-item-content')].filter(item => linkRelation[cardid].includes(item.id));
            activeLinkElement.classList.add('active-link');
            passiveLinkElements.forEach(item => {
                item.classList.add('passive-link');
            });
        }
    };
    const handleMouseLeave = () => {
        if (activeLinkElement) {
            activeLinkElement.classList.remove('active-link');
            passiveLinkElements.forEach(item => {
                item.classList.remove('passive-link');
            });
            activeLinkElement = null;
            passiveLinkElements = [];
        }
    };

    // 先渲染空div代替，等这个div将要进入屏幕再渲染真正的组件，解决一次性全部渲染的效率问题
    return <div
        className={`grid-item-container`}
        ref={gridItemRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
    >
        {renderable ? renderItem() : null}
    </div>;
}

GridItem = useOprArea((props) => ({
    isShow: props.editable,
    needCheckbox: false,
    needEdit: true,
    ...props
}), GridItem)
export default GridItem;
